// import axios from 'axios'
// import { jwtDecode } from 'jwt-decode'
// import { toast, Notification } from 'components/ui'

// const config = {
//     // baseURL: 'https://api.shipcluescargo.com',1
//      baseURL: 'https://api.shipclues.in/api/v1',
//     authentication: {
//         refreshToken: '/auth/refresh-token',
//     },
// }

// let refreshTokenRequest = null
// let isRedirecting = false
// let expirationTimeout = null

// // Check if the token is expired
// const isTokenExpired = (token) => {
//     try {
//         const decodedToken = jwtDecode(token)
//         const currentTime = Date.now() / 1000
//         return decodedToken.exp < currentTime + 60 // Add 1 minute for testing
//     } catch (error) {
//         console.error('Error decoding token:', error)
//         return true
//     }
// }

// // Handle token expiration
// const handleTokenExpiration = () => {
//     if (isRedirecting) return;
//     isRedirecting = true;

//     // Clear tokens and storage
//     localStorage.removeItem('accessToken');
//     localStorage.removeItem('refresh-token');
//     localStorage.clear();
//     sessionStorage.clear();

//     // Redirect to sign-in page
//     if (window.location.pathname !== '/sign-in') {
//         window.location.href = '/sign-in';
//     }
// }

// // Start periodic token expiry check
// const startTokenExpiryCheck = () => {
//     setInterval(() => {
//         const token = localStorage.getItem('accessToken')
//         if (token && isTokenExpired(token)) {
//             handleTokenExpiration()
//         }
//     }, 5400000) // Check every 1.5 hours
// }

// // Create an Axios instance with base URL
// const axiosInstance = axios.create({
//     baseURL: config.baseURL,
// })

// // Request interceptor
// axiosInstance.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem('accessToken')

//         if (token) {
//             if (isTokenExpired(token)) {
//                 handleTokenExpiration()
//                 return Promise.reject(new Error('Token expired'))
//             }
//             config.headers.Authorization = `Bearer ${token}`
//         }
//         return config
//     },
//     (error) => Promise.reject(error)
// )

// // Response interceptor

// axiosInstance.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config

//         if (error.response?.status === 401 && !originalRequest._retry) {
//             originalRequest._retry = true

//             try {
//                 if (!refreshTokenRequest) {
//                     refreshTokenRequest = refreshToken()
//                 }
//                 const newAccessToken = await refreshTokenRequest
//                 refreshTokenRequest = null

//                 if (newAccessToken) {
//                     localStorage.setItem('accessToken', newAccessToken)
//                     originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
//                     return axiosInstance(originalRequest)
//                 } else {
//                     handleTokenExpiration()
//                 }
//             } catch (refreshError) {
//                 handleTokenExpiration()
//             }
//         }

//         return Promise.reject(error)
//     }
// )

// // Refresh token function
// const refreshToken = async () => {
//     try {
//         const refreshToken = localStorage.getItem('refresh-token')
//         if (!refreshToken) throw new Error('No refresh token available')

//         const response = await axios.post(
//             `${config.baseURL}${config.authentication.refreshToken}`,
//             {
//                 refresh: refreshToken,
//             }
//         )
//         return response.data.access
//     } catch (error) {
//         console.error('Token refresh failed:', error)
//         return null
//     }
// }

// // Listen for localStorage changes (e.g., multi-tab logout)

// window.addEventListener('storage', (event) => {
//     if (event.key === 'accessToken' && !event.newValue) {
//         if (!isRedirecting) {
//             clearTimeout(expirationTimeout) // Clear timeout on logout
//             handleTokenExpiration()
//         }
//     }
// })
// // Start periodic token expiry check
// startTokenExpiryCheck()

// export default axiosInstance

import axios from "axios";
import { jwtDecode } from "jwt-decode";
import appConfig from "configs/app.config";

const config = {
  baseURL: "https://api.shipclues.in/api/v1",
  authentication: {
    refreshToken: "/auth/refresh-token",
  },
};

let refreshTokenRequest = null;
let isRedirecting = false;

// 🔐 Decode and check expiry
const isTokenExpired = (token) => {
  if (appConfig.enableMock) return false;
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime + 10; // expire 10s before real time
  } catch {
    return true;
  }
};

// 🔄 Refresh token
const refreshToken = async () => {
  if (appConfig.enableMock) {
    return localStorage.getItem("accessToken");
  }
  try {
    const token = localStorage.getItem("refresh-token");
    if (!token) throw new Error("No refresh token found");

    const response = await axios.post(
      `${config.baseURL}${config.authentication.refreshToken}`,
      { refresh: token }
    );

    const newAccessToken = response.data.access;
    const newRefreshToken = response.data.refresh;

    if (newAccessToken) localStorage.setItem("accessToken", newAccessToken);
    if (newRefreshToken) localStorage.setItem("refresh-token", newRefreshToken);

    return newAccessToken;
  } catch (err) {
    console.error("Token refresh failed", err);
    return null;
  }
};

// 🚪 Handle logout
const handleTokenExpiration = () => {
  if (appConfig.enableMock) return;
  if (isRedirecting) return;
  isRedirecting = true;

  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/sign-in";
};

// 🔄 Auto check token expiry and refresh
const startTokenExpiryCheck = () => {
  if (appConfig.enableMock) return;
  setInterval(async () => {
    const token = localStorage.getItem("accessToken");
    if (token && isTokenExpired(token)) {
      const newAccessToken = await refreshToken();
      if (!newAccessToken) handleTokenExpiration();
    }
  }, 240000); // every 4 minutes (before 5m expiry)
};

// Create instance
const axiosInstance = axios.create({
  baseURL: config.baseURL,
});

// 📤 Request interceptor
axiosInstance.interceptors.request.use(
  async (reqConfig) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      if (isTokenExpired(token)) {
        if (!refreshTokenRequest) {
          refreshTokenRequest = refreshToken();
        }

        const newToken = await refreshTokenRequest;
        refreshTokenRequest = null;

        if (!newToken) {
          handleTokenExpiration();
          return Promise.reject(new Error("Refresh failed"));
        }
      }

      reqConfig.headers.Authorization = `Bearer ${localStorage.getItem(
        "accessToken"
      )}`;
    }

    return reqConfig;
  },
  (err) => Promise.reject(err)
);

// 📥 Response interceptor
axiosInstance.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await refreshToken();
        if (!newAccessToken) throw new Error("Refresh failed");

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        const requestUrl = String(
          originalRequest?.url || originalRequest?.baseURL || ""
        );
        const isServiceability =
          requestUrl.includes("serviceability") ||
          String(error.config?.url || "").includes("serviceability");
        if (!isServiceability) {
          handleTokenExpiration();
        }
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

// 🔄 Listen for logout on other tabs
window.addEventListener("storage", (e) => {
  if (e.key === "accessToken" && !e.newValue) {
    handleTokenExpiration();
  }
});

// Start the expiry check
startTokenExpiryCheck();

export default axiosInstance;
